import styled, { keyframes } from 'styled-components/macro'
import { theme } from 'styled-tools'
import { media } from 'ui/rwd'
import { Section, CONTENT_WIDTH, pageGutter } from '../HomepageStyledComponents'

const whyMarkTile = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 150"><g transform="translate(105.6 25) rotate(-26 34 45)"><path fill="#fff" d="M67.7 80.9l-8.9-5.1V38.1c.7.2 1.3.3 1.9.3.9 0 1.7-.2 2.4-.6.9-.6 1.4-1.6 1.4-2.8v-7.2c0-.8-.4-1.6-1.1-2L60.2 24l-3.7-2.1-3.2-1.9-7.4-4.3-4-2.3-8.1-4.7-3.2-1.9L22.3 2 19.2.2c-.7-.4-1.6-.4-2.3 0L1.1 9.4c-.7.4-1.1 1.2-1.1 2v8.8c0 1.4.7 2.9 1.9 4.3 1 1.2 2.4 2.3 3.8 3v51.2c0 .8.4 1.6 1.1 2l10 5.8c.4.2.7.3 1.1.3.4 0 .8-.1 1.1-.3l9.3-5.4v10.7c0 .8.4 1.6 1.1 2l10 5.8c.4.2.7.3 1.1.3.4 0 .8-.1 1.1-.3l15-8.6 10.8-6.2c.7-.4 1.1-1.2 1.1-2 .3-.8-.1-1.5-.8-1.9m-5.1-52.2v6.8c0 .1 0 .2-.1.3 0 .1-.1.1-.1.2v.1h-.1l-.2.2c-.1.1-.3.1-.4.2-.2.1-.4.1-.7.1-.6 0-1.3-.1-2.1-.3V31l2.4-1.4 1.3-.9zm-13.2-7.8l-4 2.3L35.3 29s-.1 0-.1.1c0 0-.1 0-.1.1-.1 0-.1-.1-.2-.1l-4.1-2.4c-.5-.3-1-.1-1.3.3-.3.5-.1 1 .3 1.3l4.1 2.4c.1.1.2.2.2.3v7.2c0 .5-.2.9-.6 1.2-.6.4-1.9.5-3.8-.3-.1 0-.1-.1-.2-.1-1.3-.6-2.6-1.5-3.5-2.7-.1-.1-.1-.2-.2-.2-.8-1-1.3-2.1-1.3-2.9v-8.8c0-.1.1-.3.2-.3l.7-.4 12.8-7.4 2.2-1.3c.1-.1.3-.1.4 0l9.3 5.4-.7.5zM22.9 34.6c.3 1 .9 2.1 1.7 3.1.8.9 1.8 1.8 2.9 2.5L19 45.1V34.8c.7.2 1.3.3 1.9.3.7 0 1.4-.2 2-.5m5.5 7.2V51c0 .2-.1.3-.2.3s-.2.1-.4 0l-7.9-4.6 8.5-4.9zm.8-33.3c.2-.1.3-.1.4 0l9.3 5.4-10.2 5.9-4.8 2.8c-.1 0-.1.1-.2.1s-.1-.1-.2-.1l-4.1-2.4c-.5-.3-1-.1-1.3.3-.3.5-.1 1 .3 1.3l4.1 2.4c.1.1.2.2.2.3v7.2c0 .5-.2.9-.6 1.2-.6.4-1.8.5-3.5-.1-.1 0-.2-.1-.3-.1-.8-.4-1.6-.9-2.3-1.4-.5-.4-1-.8-1.4-1.3-.2-.2-.3-.4-.6-.6-.6-.9-1-1.8-1-2.6V18c0-.1 0-.1.1-.2l.1-.1.2-.1.6-.3 15-8.8zm-24.7 16c-.4-.4-.8-.7-1.2-1.1-.9-1.1-1.4-2.2-1.4-3.1v-8.9c0-.1.1-.3.2-.3l.1-.1.6-.4 5.8-3.4 9.2-5.3h.4l1.2.7 1.9 1.1 4 2.3 2.1 1.2-2.3 1.3-1.5.9L12.5 16c-.1 0-.1.1-.2.1s-.1-.1-.2-.1L8 13.6c-.5-.3-1-.1-1.3.3-.3.5-.1 1 .3 1.3l4.1 2.4c.1.1.2.2.2.3v7.2c0 .6-.2.9-.6 1.2-.5.3-1.4.5-2.7.1-.3-.1-.7-.2-1.1-.4-.8-.3-1.6-.9-2.4-1.5M28.4 79L19 84.5V62.2c0-.2.1-.3.2-.3s.2-.1.4 0l8.7 5c.1.1.2.2.2.3V79zm11.4-31.8v50.4l-.4-.2-8.9-5.1c-.1-.1-.2-.2-.2-.3V67.2c0-.7-.3-1.3-.9-1.8-.1-.1-.2-.2-.3-.2l-8.7-5c-.7-.4-1.6-.4-2.3 0-.1 0-.1.1-.2.1-.6.4-.9 1-1 1.8V84.5l-9.3-5.4-.1-.1-.1-.1V28.3c.7.2 1.3.3 1.9.3.8 0 1.5-.2 2.1-.5.1.2.1.4.2.6.1.1.1.3.2.4l.3.6c.3.5.6 1 1 1.4.4.5.9 1 1.4 1.4.7.6 1.5 1.1 2.4 1.6v11.8c0 .8.4 1.6 1.1 2l8.7 5c.1 0 .2.1.3.1.2.1.5.2.8.2h.1c.4 0 .8-.1 1.1-.3.2-.1.3-.2.5-.4.4-.4.7-1 .7-1.6v-9.6c.7.2 1.3.3 1.9.3.5 0 1-.1 1.4-.2.1 0 .3-.1.4-.1.1 0 .2-.1.3-.1.3 1 .9 2.1 1.7 3.1.1.2.3.3.4.5.9 1 2 1.8 3.2 2.4h.3zm17.1 41.4c0 .1-.1.2-.1.3 0 0 0 .1-.1.1l-15 8.6V48c.7.2 1.3.3 1.9.3.9 0 1.7-.2 2.4-.6.4-.2.6-.6.9-.9.3-.5.6-1.2.6-1.9v-7.2c0-.1 0-.2.1-.2l.1-.1L57 32v56.6zM46.6 35.7c-.1 0-.1.1-.2.1s-.1-.1-.2-.1l-4.1-2.4c-.5-.3-1-.1-1.3.3-.3.5-.1 1 .3 1.3l4.1 2.4c.1.1.2.2.2.3v7.2c0 .6-.2.9-.6 1.2-.6.4-1.9.5-3.8-.3-1.4-.6-2.7-1.6-3.7-2.7-.7-.8-1.2-1.7-1.3-2.4-.1-.3-.1-.5-.1-.7v-8.8-.1c0-.1.1-.2.2-.2l.4-.2.3-.2 15-8.6h.4l2.9 1.7 3.7 2.1.4.2.5.3 1.9 1.1-15 8.5z"/></g></svg>`
)}")`

const TILE_W = '11rem'
const TILE_H = '6rem'
const STRIPE = '5.5rem'

const whyMarkDrift = keyframes`
  from {
    -webkit-mask-position: 0 0, ${STRIPE} 0;
    mask-position: 0 0, ${STRIPE} 0;
  }
  to {
    -webkit-mask-position: 0 ${TILE_H}, ${STRIPE} -${TILE_H};
    mask-position: 0 ${TILE_H}, ${STRIPE} -${TILE_H};
  }
`

const WhySection = styled(Section)`
  position: relative;
  isolation: isolate;
  max-width: none;
  overflow: hidden;
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
  padding-left: 0;
  padding-right: 0;
  ${media.sm`
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
    padding-left: 0;
    padding-right: 0;
  `}
  ${media.md`
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
    padding-left: 0;
    padding-right: 0;
  `}

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    inset: 0;
    background-color: #b8e4e4;
  }

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    width: 250vw;
    height: 250vw;
    pointer-events: none;
    transform: translate(-50%, -50%) rotate(26deg);
    background-color: #f7b6d4;
    -webkit-mask-image: ${whyMarkTile}, ${whyMarkTile};
    -webkit-mask-repeat: repeat;
    -webkit-mask-size: ${TILE_W} ${TILE_H}, ${TILE_W} ${TILE_H};
    mask-image: ${whyMarkTile}, ${whyMarkTile};
    mask-repeat: repeat;
    mask-size: ${TILE_W} ${TILE_H}, ${TILE_W} ${TILE_H};
    animation: ${whyMarkDrift} 24s linear infinite;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
`

const WhyHeading = styled.h2`
  max-width: ${CONTENT_WIDTH};
  margin: 0 auto 2.75rem;
  ${pageGutter};
  font-size: 1.75rem;
  font-weight: bold;
  line-height: 1.2;
  letter-spacing: -0.02em;
  text-align: left;
  ${media.sm`
    margin-bottom: 3.25rem;
    font-size: 2rem;
  `}
`

const WhyList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  max-width: ${CONTENT_WIDTH};
  margin: 0 auto;
  ${pageGutter};
  gap: 1.25rem;
  text-align: left;
  box-sizing: border-box;
  ${media.md`
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1.5rem;
  `}
`

const WhyTitle = styled.h3`
  margin: 0;
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.3;
  letter-spacing: -0.02em;

  &::before {
    content: '';
    display: block;
    width: 1.75rem;
    height: 3px;
    margin-bottom: 0.9rem;
    background-color: ${theme('primary')};
    transition: width 0.3s ease;
  }
`

const WhyItem = styled.article`
  min-width: 0;
  box-sizing: border-box;
  padding: 1.75rem 1.5rem 2rem;
  background-color: ${theme('white')};
  ${media.sm`
    padding: 2rem 1.75rem 2.25rem;
  `}

  &:hover ${WhyTitle}::before,
  &:focus-within ${WhyTitle}::before {
    width: 3.25rem;
  }

  @media (prefers-reduced-motion: reduce) {
    ${WhyTitle}::before {
      transition: none;
    }
  }
`

const WhyBody = styled.p`
  margin: 0.75rem 0 0;
  font-size: 1.0625rem;
  line-height: 1.6;
  color: ${theme('midGray')};
  ${media.sm`
    font-size: 1.125rem;
  `}
`

export { WhySection, WhyHeading, WhyList, WhyItem, WhyTitle, WhyBody }
